import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NetworkService } from '../network/network.service';
import { AlertService } from '../alert/alert.service';
import { SpinnerService } from '../spinner/spinner.service';
import { RetornoModel } from '../../models/retornoModel';
import { Global } from '../../helpers/global';
import { EmpresaModel } from 'src/app/models/empresaModel';
import { GrupoModel, DetalheGrupoModel } from 'src/app/models/grupoModel';
import { ProdutoModel, DetalheProdutoModel, DetalheGrupoAcompanhamentoModel } from 'src/app/models/produtoModel';
import { CarrinhoModel } from 'src/app/models/carrinhoModel';
import { AcompanhamentoModel, AcompanhamentoPedidoProdutoModel, DetalheAcompanhamentoModel } from 'src/app/models/acompanhamentoModel';
import { IdentificacaoModel } from 'src/app/models/identificacaoModel';
import { enFormaBusca } from 'src/app/models/enums/enFormaBusca';
import { enTipoAcompanhamento } from 'src/app/models/enums/enTipoAcompanhamento';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private alertSrv: AlertService,
    private spinnerSrv: SpinnerService,
    private networkSrv: NetworkService) {
  }

  private ObterHeaderHttp(): HttpHeaders {
    let header = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'OPTIONS,GET,POST,PUT,DELETE',
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      'Accept': 'application/json',
      'content-type': 'application/json'
    });

    return header;
  }

  public VerificaServicoOnline(): Promise<RetornoModel> {
    return new Promise((resolve) => {
      let retorno = new RetornoModel();
      retorno.Sucesso = true;
      resolve(retorno);
    });
  }

  async CarregarInformacoesEmpresa(): Promise<EmpresaModel> {
    let c = () => {
      let retorno: EmpresaModel = new EmpresaModel();

      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa,
          formaBusca: enFormaBusca.Individual.valueOf()
        }
        let jsonFinal: string = JSON.stringify(p);

        let url = Global.UrlServico + 'emp/obter/';
        let header = this.ObterHeaderHttp();
        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);

                retorno.Sucesso = r.S;
                retorno.Mensagem = r.ME;
                retorno.Codigo = objResp.codigo;
                retorno.Nome = objResp.nome;
                retorno.Telefone = objResp.telefone;
                retorno.Whatsapp = "55" + objResp.whatsapp;
                retorno.Mensagem1 = objResp.mensagem1;
                retorno.Mensagem2 = objResp.mensagem2;
                retorno.PermiteItemEsgotado = objResp.permiteItemEsgotado;
                retorno.ExibeGrupoProdutos = objResp.exibeGrupoProdutos;
                retorno.RedesSociaisEmail = objResp.redesSociaisEmail;
                retorno.RedesSociaisFacebook = objResp.redesSociaisFacebook;
                retorno.RedesSociaisInstagram = objResp.redesSociaisInstagram;
                retorno.RedesSociaisSite = objResp.redesSociaisSite;
                retorno.RedesSociaisTelefone = objResp.redesSociaisTelefone;
                retorno.RedesSociaisWhatsapp = objResp.redesSociaisWhatsapp;
                retorno.CodigoCor = objResp.codigoCor;
                retorno.Cor = this.ObterCor(retorno.CodigoCor);
                retorno.CorTexto = this.ObterCorTexto(retorno.CodigoCor);

                if (objResp.imagem) {
                  retorno.PathImagem = "data:image/jpeg;base64," + objResp.imagem;
                }
                else {
                  retorno.PathImagem = "../../../assets/noImage.png"
                }

                if (objResp.imagemFundo) {
                  retorno.PathImagemFundo = "data:image/jpeg;base64," + objResp.imagemFundo;
                }
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              //this.spinnerSrv.Hide();

              retorno.Mensagem = 'Não foi possível obter as informações desta empresa';

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: EmpresaModel = new EmpresaModel();

    await c()
      .then(res => {
        ret = (res as EmpresaModel);
      })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      });

    return ret;
  }

  ObterCor(CodigoCor: number): string {
    let cor: string;

    switch (CodigoCor) {
      case 0:
        //Amarelo
        cor = '#ffc129';
        break;
      case 1:
        //Laranja
        cor = '#FFA500';
        break;
      case 2:
        //Vermelho
        cor = '#fc4242';
        break;
      case 3:
        //Rosa
        cor = '#FFB6C1';
        break;
      case 4:
        //Roxo
        cor = '#9370db';
        break;
      case 5:
        //Azul
        cor = '#38bfec';
        break;
      case 6:
        //Verde
        cor = '#81cc4c';
        break;
      case 7:
        //Control
        cor = '#f0f0f0';
        break;
      case 8:
        //Cinza Claro
        cor = '#738391';
        break;
      case 9:
        //Cinza Escuro
        cor = '#2e3745';
        break;
      case 10:
        //Preto
        cor = '#000000';
        break;
    }

    return cor;
  }

  ObterCorTexto(CodigoCor: number): string {
    let corTexto: string;

    switch (CodigoCor) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        corTexto = 'black';
        break;
      case 9:
      case 10:
        corTexto = 'white';
        break;
    }

    return corTexto;
  }

  async CarregarInformacoesGrupoProduto(): Promise<GrupoModel> {
    let c = () => {
      let retorno: GrupoModel = new GrupoModel();

      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa
        }
        let jsonFinal: string = JSON.stringify(p);

        let url = Global.UrlServico + 'grp/obter/';
        let header = this.ObterHeaderHttp();
        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);

                retorno.Sucesso = r.S;
                retorno.Mensagem = r.ME;
                retorno.Relacao = [];

                objResp.forEach(e => {
                  let p: DetalheGrupoModel = new DetalheGrupoModel();
                  p.Codigo = e.codigo;
                  p.Nome = e.nome;
                  p.PossuiDesconto = e.possuiDesconto;
                  p.CodigoNivel = e.codigoNivel;
                  p.CodigoGrupoNivelSuperior = e.codigoGrupoNivelSuperior;

                  if (e.imagem) {
                    //p.PathImagem = Global.UrlFotos + e.imagem;
                    p.PathImagem = "data:image/jpeg;base64," + e.imagem;
                  }
                  else {
                    p.PathImagem = "../../../assets/noImage.png"
                  }

                  retorno.Relacao.push(p);
                });
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              //this.spinnerSrv.Hide();

              retorno.Mensagem = 'Não foi possível obter a relação de grupos de produtos';

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: GrupoModel = new GrupoModel();

    await c()
      .then(res => {
        ret = (res as GrupoModel);
      })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      });

    return ret;
  }

  async CarregarInformacoesProdutos(pagina: number): Promise<ProdutoModel> {
    let c = () => {
      let retorno: ProdutoModel = new ProdutoModel();
      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa,
          pagina: pagina,
          cardapio: true
        }
        let jsonFinal: string = JSON.stringify(p);

        let url = Global.UrlServico + 'prod/obter/';
        let header = this.ObterHeaderHttp();
        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;

              Global.CarregamentoCompleto = (!r.O);

              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);

                retorno.Sucesso = r.S;
                retorno.Mensagem = r.ME;
                retorno.Relacao = [];
                retorno.RelacaoCarrinho = [];

                objResp.forEach(e => {
                  let p: DetalheProdutoModel = new DetalheProdutoModel();
                  p.Codigo = e.codigoProduto;
                  p.CodigoGrupo = e.codigoGrupo
                  p.Nome = e.nome;
                  p.PossuiDesconto = e.possuiDesconto;
                  p.Descricao = e.descricao;
                  p.ValorNutricional = e.valorNutricional;
                  p.Avisos = e.avisos;
                  p.Preco = e.preco;
                  p.Quantidade = 1;
                  p.QuantidadeDisponivel = e.quantidadeDisponivel;
                  p.QuantidadePessoas = e.quantidadePessoas;
                  p.Vegetariano = e.Vegetariano;
                  p.Vegano = e.vegano;
                  p.Organico = e.organico;
                  p.SemAcucar = e.semAcucar;
                  p.ZeroLactose = e.zeroLactose;

                  p.RelacaoGrupoAcompanhamento = [];

                  if (e.relacaoAcompanhamento) {
                    e.relacaoAcompanhamento.forEach(ac => {
                      let grupoAcompanhamento: DetalheGrupoAcompanhamentoModel = new DetalheGrupoAcompanhamentoModel();
                      grupoAcompanhamento.CodigoGrupoAcompanhamento = ac.codigoGrupoAcompanhamento;

                      p.RelacaoGrupoAcompanhamento.push(grupoAcompanhamento);
                    });
                  }

                  if (e.imagem) {
                    //p.PathImagem = Global.UrlFotos + e.imagem;
                    p.PathImagem = "data:image/jpeg;base64," + e.imagem;
                  }
                  else {
                    p.PathImagem = "../../../assets/carregando.gif"
                  }

                  retorno.Relacao.push(p);
                });
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              Global.CarregamentoCompleto = true;

              retorno.Mensagem = 'Não foi possível obter a relação de produtos';

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: ProdutoModel = new ProdutoModel();

    await c()
      .then(res => { ret = (res as ProdutoModel); })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      });

    return ret;
  }

  async CarregarInformacoesImagensProdutos(pagina: number): Promise<ProdutoModel> {
    let c = () => {
      let retorno: ProdutoModel = new ProdutoModel();
      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa,
          pagina: pagina,
          cardapio: true
        }
        let jsonFinal: string = JSON.stringify(p);

        let url = Global.UrlServico + 'prod/obterImagens/';
        let header = this.ObterHeaderHttp();
        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;

              Global.CarregamentoCompletoImagem = (!r.O);

              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);

                retorno.Sucesso = r.S;
                retorno.Mensagem = r.ME;
                retorno.Relacao = [];
                retorno.RelacaoCarrinho = [];

                objResp.forEach(e => {
                  let p: DetalheProdutoModel = new DetalheProdutoModel();
                  p.Codigo = e.codigoProduto;

                  if (e.imagem) {
                    p.PathImagem = "data:image/jpeg;base64," + e.imagem;
                  }
                  else {
                    p.PathImagem = "../../../assets/noImage.png"
                  }

                  retorno.Relacao.push(p);
                });
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              Global.CarregamentoCompletoImagem = true;

              retorno.Mensagem = 'Não foi possível obter a relação de imagens de produtos';

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: ProdutoModel = new ProdutoModel();
    await c()
      .then(res => { ret = (res as ProdutoModel); })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      });

    return ret;
  }

  async SincronizarCarrinhoCompra(carrinho: CarrinhoModel,
    relacaoProdutos: DetalheProdutoModel[],
    relacaoAcompanhamento: DetalheAcompanhamentoModel[]): Promise<RetornoModel> {
    let c = () => {
      let retorno: RetornoModel = new RetornoModel();

      return new Promise(async (resolve) => {
        if ((carrinho) && (relacaoProdutos)) {
          let relacaoAcompanhamntoDto: any[] = [];
          relacaoAcompanhamento.forEach(e => {
            if (e.QuantidadeSelecionada > 0) {
              let p = {
                acompanhamento: e.Acompanhamento,
                quantidade: e.QuantidadeSelecionada,
                valor: e.ValorAcompanhamento
              }

              relacaoAcompanhamntoDto.push(p);
            }
          });

          let relacaoProdutosDto: any[] = [];
          relacaoProdutos.forEach(e => {
            let p = {
              //id: Global.IdentificacaoEmpresa,
              codigo: e.Codigo,
              observacao: e.ObservacaoNoPedido,
              quantidade: e.Quantidade,
              valorUnitario: e.Preco,
              relacaoAcompanhamento: []
            };

            if ((e.RelacaoGrupoAcompanhamento) && (e.RelacaoGrupoAcompanhamento.length > 0) && (e.RelacaoAcompanhamentoCarrinho)) {
              let maiorValor = 0;
              let valorMedio = 0;
              let valorDizima = 0;
              e.RelacaoAcompanhamentoCarrinho.forEach(x => {
                x.RelacaoAcompanhamento.forEach(y => {
                  if (x.MaiorValor)
                    maiorValor = Math.max.apply(null,
                      x.RelacaoAcompanhamento.map(function (o) { return o.Selecionado ? o.ValorAcompanhamento : 0; }));
                  if (x.Pizza) {
                    if (x.MaiorValor) {
                      maiorValor = Math.max.apply(null,
                        x.RelacaoAcompanhamento.map(function (o) { return o.Selecionado ? o.ValorAcompanhamento : 0; }));
                      valorMedio = (maiorValor / x.QuantidadeMaximaGrupo);
                      valorDizima = maiorValor - (valorMedio * x.QuantidadeMaximaGrupo);
                    }
                    else {
                      x.RelacaoAcompanhamento.forEach(z => {
                        if (z.Selecionado) {
                          valorMedio += ((z.ValorAcompanhamento / x.QuantidadeMaximaGrupo) * z.QuantidadeSelecionada);
                        }
                      });
                      valorMedio = valorMedio / x.QuantidadeMaximaGrupo;

                      x.RelacaoAcompanhamento.forEach(z => {
                        if (z.Selecionado) {
                          maiorValor += ((z.ValorAcompanhamento / x.QuantidadeMaximaGrupo) * z.QuantidadeSelecionada);
                        }
                      });

                      valorDizima = (maiorValor - (valorMedio * x.QuantidadeMaximaGrupo));
                    }
                  }

                  if (y.Selecionado) {
                    if (valorDizima > 0) {
                      // Faço o ajuste da dízima
                      if ((y.ValorAcompanhamento - valorDizima) <= 0) {
                        // A dízima torna o valor zero ou negativo e por isso faço o devido ajuste
                        valorDizima -= (y.ValorAcompanhamento - 0.01);
                        valorMedio = 0.01;
                      }
                      else {
                        let valorUnitario = y.ValorAcompanhamento;
                        if ((y.QuantidadeSelecionada > 0) && (valorDizima % y.QuantidadeSelecionada == 0)) {
                          // Posso descarregar a dízima normalmente
                          valorMedio = valorUnitario + valorDizima / y.QuantidadeSelecionada;
                          valorDizima = 0;
                        }
                        else if (y.QuantidadeSelecionada == 1) {
                          // Posso descarregar a dízima normalmente
                          valorMedio = valorUnitario + valorDizima;
                          valorDizima = 0;
                        }
                      }
                    }

                    let valorAcompanhamento = 0;
                    if (x.Pizza) {
                      valorAcompanhamento = valorMedio;
                    }
                    else {
                      valorAcompanhamento = x.MaiorValor ? maiorValor : y.ValorAcompanhamento;
                    }

                    let acomp = {
                      nome: x.NomeGrupo,
                      acompanhamento: y.Acompanhamento,
                      quantidade: y.QuantidadeSelecionada,
                      valorAcompanhamento: valorAcompanhamento,
                      codigoProdutoAcompanhamento: y.CodigoProdutoAcompanhamento,
                      quantidadeProdutoAcompanhamento: y.QuantidadeProdutoAcompanhamento
                    }

                    p.relacaoAcompanhamento.push(acomp);
                  }
                });
              });
            }

            relacaoProdutosDto.push(p);
          });

          let carrinhoDto = {
            id: Global.IdentificacaoEmpresa,
            codigoMesa: Global.CodigoMesa,
            codigoMesaPedido: Global.CodigoMesaPedido == 0 ? null : Global.CodigoMesaPedido,
            ehDispositivoVinculado: Global.EhDispositivoVinculado,
            //valorTotal: carrinho.ValorTotal,
            relacaoProdutos: relacaoProdutosDto,
            relacaoAcompanhamento: relacaoAcompanhamntoDto
          };

          let jsonFinal: string = JSON.stringify(carrinhoDto);
          let url = Global.UrlServico + 'ap/sinc/' + Global.CodigoMesaCripto;
          let header = this.ObterHeaderHttp();

          let options = {
            headers: header
          };

          if (!Global.EhProducao) {
            console.log(header);
            console.log(options);
            console.log(jsonFinal);
          }

          try {
            this.spinnerSrv.Show('Sincronizando pedido...', 2000);

            await this.http.post(url, jsonFinal, options).subscribe(
              result => {
                if (!Global.EhProducao) {
                  console.log('Sucesso!!!');
                  console.log(result);
                }

                let r: any = result;
                retorno.Sucesso = r.S;
                retorno.Mensagem = r.M;

                if ((r.S) && (r.O)) {
                  let objResp = JSON.parse(r.O);

                  retorno.Objeto = {
                    CodigoCarrinho: objResp.codigoCarrinho,
                    CodigoMesaPedido: objResp.codigoMesaPedido,
                    TempoAtendimento: objResp.tempoAtendimento,
                    UrlPagamento: objResp.urlPagamento,
                    QrCode: "data:image/jpeg;base64," + objResp.qrCode,
                    TempoExpiracaoEmMinutos: objResp.tempoExpiracaoEmMinutos
                  };
                }
                else if (r.errors[0]) {
                  let objResp = JSON.parse(r.errors[0]);
                  if (objResp.exibirAoConsumidor) {
                    retorno.Sucesso = false;
                    retorno.Mensagem = objResp.mensagem;
                    retorno.MesaJahEstahFechada = !objResp.permiteCriarPedido;
                  }
                  else {
                    retorno.Sucesso = false;
                    retorno.Mensagem = 'Não foi possível sincronizar este pedido. Tente novamente!';
                    retorno.MesaJahEstahFechada = !objResp.permiteCriarPedido;
                  }
                }
                else {
                  retorno.Sucesso = false;
                  retorno.Mensagem = r.ME;
                }
                resolve(retorno);
              },
              err => {
                //this.spinnerSrv.Hide();

                retorno.Mensagem = 'Não foi possível sincronizar este pedido. Tente novamente!';
                retorno.Erro = err;

                resolve(retorno);
              });
          }
          catch {
            retorno.Sucesso = false;
            retorno.Mensagem = 'Não foi possível sincronizar este pedido. Tente novamente!';
          }
          finally {
            this.spinnerSrv.Hide();
          }
        }
        else {
          //this.spinnerSrv.Hide();
          retorno.Mensagem = 'Nenhuma informação de pedido foi encontrado para sincronização';
          resolve(retorno);
        }
      });
    };

    let ret: RetornoModel = new RetornoModel();

    await c()
      .then(res => {
        ret = (res as RetornoModel);
      })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      })
      .finally(() => {
        this.spinnerSrv.Hide();
      });

    //this.spinnerSrv.Hide();
    return ret;
  }

  async CarregarInformacoesAcompanhamentoPedido(): Promise<AcompanhamentoModel> {
    let c = () => {
      let retorno: AcompanhamentoModel = new AcompanhamentoModel();

      return new Promise(async (resolve) => {
        let p = {
          id: Global.IdentificacaoEmpresa
        };

        let jsonFinal: string = JSON.stringify(p);
        let url = Global.UrlServico + 'carr/acomp/';
        let header = this.ObterHeaderHttp();

        let options = {
          headers: header
        };

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              retorno.Sucesso = r.S;
              retorno.Mensagem = r.M;
              retorno.Relacao = [];

              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);

                objResp.forEach(e => {
                  let p: DetalheAcompanhamentoModel = new DetalheAcompanhamentoModel();
                  p.CodigoGrupoAcompanhamento = e.codigoGrupoAcompanhamento;
                  p.NomeGrupoAcompanhamento = e.nomeGrupoAcompanhamento;
                  p.Codigo = e.codigo;
                  p.Acompanhamento = e.acompanhamento;
                  p.DetalhesAcompanhamento = e.detalhesAcompanhamento;
                  p.QuantidadeMaximaAcompanhamento = e.quantidadeMaximaAcompanhamento;
                  p.ValorAcompanhamento = e.valorAcompanhamento;
                  p.QuantidadeMaximaGrupo = e.quantidadeMaximaGrupo;
                  p.Obrigatorio = e.obrigatorio;
                  p.TipoAcompanhamento = (e.tipoAcompanhamento as enTipoAcompanhamento);
                  p.QuantidadeSelecionada = 0;
                  p.MaiorValor = e.maiorValor;
                  p.Pizza = e.pizza;

                  if (e.relacaoProdutoAcompanhamento) {
                    p.RelacaoProdutoAcompanhamento = [];
                    e.relacaoProdutoAcompanhamento.forEach(a => {
                      let x: AcompanhamentoPedidoProdutoModel = new AcompanhamentoPedidoProdutoModel();
                      x.CodigoProduto = a.CodigoProduto;
                      x.CodigoGrupoAcompanhamento = a.CodigoGrupoAcompanhamento;
                      x.Codigo = a.Codigo;
                      x.CodigoProdutoAcompanhamento = a.CodigoProdutoAcompanhamento;
                      x.QuantidadeProdutoAcompanhamento = a.QuantidadeProdutoAcompanhamento;

                      p.RelacaoProdutoAcompanhamento.push(x);
                    });
                  }
                  retorno.Relacao.push(p);
                });
              }

              resolve(retorno);
            },
            err => {
              retorno.Sucesso = false;
              retorno.Mensagem = 'Não foi possível carregar informações de acompanhamento do pedido da empresa';

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: AcompanhamentoModel = new AcompanhamentoModel();

    await c().then(res => { ret = (res as AcompanhamentoModel); })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      })
      .finally(() => {
        //this.spinnerSrv.Hide();
      });

    //this.spinnerSrv.Hide();
    return ret;
  }

  async IdentificarEmpresa(): Promise<IdentificacaoModel> {
    let c = () => {
      let retorno: IdentificacaoModel = new IdentificacaoModel();

      //Global.UrlChamadora = "http://192.168.1.114:11500/uT2AL_t328ypLRZLAyxK4w";
      //Global.UrlChamadora = "http://192.168.1.114:11000/ia98_aIPjbeMjIWcCbHAgA";

      //Cardápio
      //Global.UrlChamadora = "http://localhost:8100/";
      // 1: uT2AL_t328ypLRZLAyxK4w
      //Global.UrlChamadora = "http://localhost:8100/uT2AL_t328ypLRZLAyxK4w";
      // 2: oW-_KJXU-3cRAakCgYImTw
      //Global.UrlChamadora = "http://localhost:8100/oW-_KJXU-3cRAakCgYImTw";
      // 3: fxmpezN16fPp1t75ZvnD7Q
      //Global.UrlChamadora = "http://localhost:8100/fxmpezN16fPp1t75ZvnD7Q";

      return new Promise(async (resolve) => {
        //Pego o identificador único
        let uuid = null;

        //Se existir o Identificador em chache eu uso o em cache
        let identificador = localStorage.getItem('IdentificadorSelfOrderingWaybit');
        if (identificador != null) {
          uuid = identificador.trim();
        }
        //Se não eu crio um novo e armazendo em cache no dispositivo
        else {
          uuid = uuidv4();
          localStorage.setItem('IdentificadorSelfOrderingWaybit', uuid);
        }

        let codigoMesaPedido = Global.CodigoMesaPedido;
        let p = {
          urlChamadora: Global.UrlChamadora,
          codigoMesaPedido: codigoMesaPedido,
          uuid: uuid
        };

        let jsonFinal: string = JSON.stringify(p);
        let url = Global.UrlServico + 'emp/self-o/';
        let header = this.ObterHeaderHttp();

        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(jsonFinal);
          console.log(url);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              retorno.Sucesso = r.S;
              retorno.Mensagem = r.M;

              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);
                retorno.Id = objResp.codigoIdCliente;
                retorno.EmpresaAtiva = objResp.ativa;
                retorno.PermiteCriarPedido = objResp.permiteCriarPedido;
                retorno.CodigoMesa = objResp.codigoMesa;
                retorno.CodigoMesaCripto = objResp.codigoMesaCripto;
                retorno.EhDispositivoVinculado = objResp.ehDispositivoVinculado;
                retorno.VinculoTablet = objResp.vinculoTablet;
                retorno.UrlChamadoraAjustada = objResp.urlChamadoraAjustada;
              }
              else if (r.errors[0]) {
                let objResp = JSON.parse(r.errors[0]);
                if (objResp.exibirAoConsumidor) {
                  retorno.ExibirAoConsumidor = objResp.exibirAoConsumidor;
                  retorno.Sucesso = false;
                  retorno.Mensagem = objResp.mensagem;
                }
              }
              else {
                retorno.Sucesso = false;
                retorno.Mensagem = 'Não foi possível identificar esta empresa ou mesa!';
              }

              resolve(retorno);
            },
            err => {
              retorno.Sucesso = false;

              if (err) {
                err.forEach(e => {
                  retorno.Mensagem += e + "\n";
                });
              }
              else {
                retorno.Mensagem = 'Não foi possível identificar esta empresa';
              }

              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: IdentificacaoModel = new IdentificacaoModel();

    await c().then(res => { ret = (res as IdentificacaoModel); })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      })
      .finally(() => {
        //this.spinnerSrv.Hide();
      });

    return ret;
  }

  async RegistrarAcessoAplicacao(): Promise<RetornoModel> {
    let c = () => {
      let retorno: RetornoModel = new RetornoModel();

      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa,
        }
        let jsonFinal: string = JSON.stringify(p);

        let url = Global.UrlServico + 'emp/acesso/';
        let header = this.ObterHeaderHttp();
        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();

        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              if (r.S) {
                retorno.Sucesso = r.S;
                retorno.Mensagem = r.ME;
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              retorno.Mensagem = 'Não foi possível registrar o acesso desta empresa';
              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: RetornoModel = new RetornoModel();
    await c()
      .then(res => {
        ret = (res as RetornoModel);
      })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      });

    return ret;
  }

  async FecharMesaPedido(): Promise<RetornoModel> {
    let c = () => {
      let retorno: RetornoModel = new RetornoModel();

      return new Promise(async (resolve) => {
        // Monto o objeto que vou serializar no POST
        let p = {
          id: Global.IdentificacaoEmpresa,
          codigoMesa: Global.CodigoMesa,
          codigoMesaPedido: Global.CodigoMesaPedido
        }
        let jsonFinal: string = JSON.stringify(p);
        let url = Global.UrlServico + 'ap/encerrar/' + Global.CodigoMesaCripto;
        let header = this.ObterHeaderHttp();

        let options = {
          headers: header
        };

        if (!Global.EhProducao) {
          console.log(header);
          console.log(options);
          console.log(jsonFinal);
        }

        let online = await this.VerificaServicoOnline();
        if (online.Sucesso) {
          await this.http.post(url, jsonFinal, options).subscribe(
            result => {
              if (!Global.EhProducao) {
                console.log('Sucesso!!!');
                console.log(result);
              }

              let r: any = result;
              retorno.Sucesso = r.S;
              retorno.Mensagem = r.ME;

              if ((r.S) && (r.O)) {
                let objResp = JSON.parse(r.O);
                retorno.MesaJahEstahFechada = objResp.mesaJahEstahFechada;
              }
              else {
                retorno.Mensagem = Global.isNullOrEmpty(r.ME)
                  ? r.ME
                  : 'Nenhuma resposta válida do servidor';
              }

              resolve(retorno);
            },
            err => {
              retorno.Mensagem = 'Não foi possível solicitar o fechamento dessa mesa. Chame um Garçom!';
              resolve(retorno);
            });
        }
        else {
          retorno.Mensagem = online.Mensagem;
          resolve(retorno);
        }
      });
    };

    let ret: RetornoModel = new RetornoModel();

    await c()
      .then(res => {
        ret = (res as RetornoModel);
      })
      .catch(e => {
        ret.Sucesso = false;
        ret.Mensagem = "Erro desconhecido realizando esta operação. Tente novamente"
        console.log(e)
      })
      .finally(() => {
        this.spinnerSrv.Hide();
      });

    return ret;
  }
}
